import { render, staticRenderFns } from "./hollow-guide.vue?vue&type=template&id=486e10f9&scoped=true&lang=pug&"
import script from "./hollow-guide.vue?vue&type=script&lang=js&"
export * from "./hollow-guide.vue?vue&type=script&lang=js&"
import style0 from "./hollow-guide.vue?vue&type=style&index=0&id=486e10f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e10f9",
  null
  
)

export default component.exports